import React, { useContext, useEffect, useState } from 'react';
import styles from './SearchBarButton.module.scss';
import { SearchIcon } from '../../icons/Icons';
import { AppContext } from '../../../context/AppContext';
import { useHistory } from 'react-router-dom';
import { RouteWithState } from '../../../lib/util';

const SearchBarButton = ( props: any ) => {
  const appContext = useContext(AppContext);
  const { planCode, chosenSpecialty, location, name, planState, directoryListType, distance, isDisabled, search, updateSearch, shortPlanName } = appContext;
  //const { isDisabled } = props;
  //const [ isDisabled, setIsDisabled ] = useState<boolean>(false);
  const [ buttonClassName, setButtonClassName ] = useState<string>(``);
  const history = useHistory();
  //let buttonClassName = `${styles.searchButton}${isValidZip ? '' : ` ${styles.disabled}`}`;
  //alert(shortPlanName);
  useEffect(() => {
    const newClassName = `${styles.searchButton}${isDisabled ? ` ${styles.disabled}` : ''}`
    //console.log(newClassName);
    setButtonClassName(newClassName)
  }, [isDisabled]);
  //Click of Search 
  const handleSearch = () => {
    if (!isDisabled) {
      //const path = RouteWithState(`/results/${planCode}/${directoryListType}/${chosenSpecialty || 'undefined'}/${name || 'undefined'}/${location || 'undefined'}?distance=${distance.distance}`, appContext);//Original
	  const path = RouteWithState(`/results/${shortPlanName}/${directoryListType}/${chosenSpecialty || 'undefined'}/${name || 'undefined'}/${location || 'undefined'}?distance=${distance.distance}`, appContext);
      history.push(path);

      if (history.location.pathname.includes('/results')) {
        window.location.reload();
        // why was this here?
      }
  }};


  

  return (
    <div className={styles.searchButtonContainer}>
      <button className={buttonClassName} onClick={() => handleSearch()}>
        <span className={`${styles.icon} ${styles.baseline}`}>
          <SearchIcon />
        </span>
        <span>Search</span>
      </button>
    </div>
  );
};

export default SearchBarButton;
